// extracted by mini-css-extract-plugin
module.exports = {"pipeTable":"PipeSizePrint_pipeTable__3R3Pf","alignLeft":"PipeSizePrint_alignLeft__U1xJX","alignRight":"PipeSizePrint_alignRight__1yEcJ"};